import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/EDEN-HOUSE-THE-PARK.webp';

const Project_twenty = () => {

  return (
    <>
       
             <div className='project_1_work' id="workBanner">
       
               <div className="container project_our_work">
       
                 <div className="heading">
                   <h1>Eden House, The Palm</h1>
                 </div>
       
                 <hr></hr>
                 <div className='project_section'>
                   <div className="project_section_content">
                     <h1 className="project_scope">Scope of Work</h1>
                     <p>A boutique luxury residential development on Palm Jumeirah offering high-end apartments with premium finishes and full
                        resort-style amenities. Positioned as an exclusive private residential address on one of Dubai's most iconic waterfront
                        locations.</p>
                     <p>MAIN CONTRACTOR : -</p>
                     <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                     <p>GEMCO SCOPE OF WORKS : Plumbing and CHW works</p>
                     {/* <h2 className="project_years">2014 – 2022</h2> */}
                   </div>
                   <div className='project_1_card'>
                     <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                   </div>
                 </div>
               </div>
             </div>
       
           </>

  )
}

export default Project_twenty